import register from '@/components/features/cms/blocks/DynamicProductSlider/register';
import { DynamicProductSlider } from './DynamicProductSlider';

register(DynamicProductSlider);
